import api from 'api'
import { defaultHandleError } from 'util/downloadFile'

export const downloadCSVExportarCadastrosDuplicados = () => {
  return api.exportarCadastrosDuplicados.exportarCSV().catch(defaultHandleError)
}
